import React from 'react';
import { message, Modal, notification } from 'antd';
import io from 'socket.io-client';

import AppBar from 'src/components/AppBar';
import Footer from 'src/components/Footer';
import GameCarousel from 'src/components/GameCarousel';
import GameList from 'src/components/GameList';
import InfoSection from 'src/components/InfoSection';
import ModalRegister from 'src/components/ModalRegister';
import ModalTranc from 'src/components/ModalTranc';
import ModalWaiting from 'src/components/ModalWaiting';
import ModalWithdrawSelect from 'src/components/ModelWithdrawSelect';
import ModalWithdraw from 'src/components/ModalWithdraw';
import ModalTrancSelect from 'src/components/ModalTrancSelect';
import ModalQR from 'src/components/ModalQR';
import ModalBindSelect from 'src/components/ModalBindSelect';
import ModalOrders from 'src/components/ModalOrders';
import StatusBar from 'src/components/StatusBar';
import StatusBarAuthed from 'src/components/StatusBarAuthed';

import {
  E_FAILED_APICALL_TO_APIBK_WITHDRAW,
  E_BALANCE_NOT_ENOUGH,
} from 'src/utils/ErrorCode';

import { v4 as uuidv4 } from 'uuid';

import i18n from 'src/i18n';

import { ApiContext } from 'src/utils/ApiContext';

/**
 * @typedef {import('@src/utils/types').RegistData} RegistData
 * @typedef {import('@src/utils/types').TrancRequest} TrancRequest
 */

export default class Home extends React.Component {
  static contextType = ApiContext;

  constructor(props) {
    super(props);

    this.state = { time: new Date() };
  }

  componentWillMount() {
    // this.context.fetchApi('/api', null, 'get')
    this.context.getToken();
  }

  componentDidMount() {
    let serverIP = null;
    if (process.env.REACT_APP_API) {
      serverIP = process.env.REACT_APP_API;
    }

    console.log('[socket] serverIP', serverIP);
    const socket = io(serverIP);
    console.dir(socket);

    socket.on('connect', () => {
      console.log('[socket] connect');

      setTimeout(() => {
        if (this.context.user != null) {
          this.context.refreshUser();
        }
      }, 100);
    });

    socket.on('refresh', async (data) => {
      console.log('[socket] refresh', data);

      this.context.refreshUser();
    });

    socket.on('bind', async (data) => {
      console.log('[socket] bind', data);

      const { wid } = data;

      this.context.bind(wid);

      notification.success({
        message: i18n.t('statusBarAuthed.bind'),
        description: i18n.t('statusBarAuthed.bindState'),
      })
    });

    socket.on('unbind', async (data) => {
      console.log('[socket] unbind', data);

      this.context.unbind();

      notification.info({
        message: i18n.t('statusBarAuthed.unbind'),
        description: i18n.t('Home.Success'),
      })
    });

    socket.on('E Pay Notification', async (data) => {
      console.log('[socket] store notify', data);

      if (
        data.Type === 'Store.TopupNotify' ||
        data.Type === 'Store.TopupNotify.Fail' ||
        data.Type === 'Store.RemitNotify' ||
        data.Type === 'Store.RemitNotify.Fail'
      ) {
        const res = await this.context.refreshUser();
        if (res) {
          // 1. 充值/提款成功 (最後一個畫面是顯示 QRCode，所以把它關掉)
          let modalQR = this.context.ModalQR;
          modalQR.Show = false;
          this.context.setModalQR(modalQR);
          // 以防萬一也關掉
          this.context.setShowTrancSelect(false);
          this.context.setShowTranc(false);
          this.context.setShowTrancUSDT(false);

          // 2. 顯示通知
          switch (data.Type) {
            case 'Store.TopupNotify':
              notification.success({
                message: '充值通知',
                description: `充值 ${data.Meta.RealAmount} 成功`,
                placement: 'top',
              });
              break;
            case 'Store.TopupNotify.Fail':
              notification.error({
                message: '充值失敗通知',
                description: `充值 ${data.Meta.RealAmount} 失敗`,
                placement: 'top',
              });
              break;
            case 'Store.RemitNotify':
              notification.success({
                message: '提現通知',
                description: `提現 ${data.Meta.RealAmount} 成功`,
                placement: 'top',
              });
              break;
            case 'Store.RemitNotify.Fail':
              notification.error({
                message: '提現失敗通知',
                description: `充值 ${data.Meta.RealAmount} 失敗`,
                placement: 'top',
              });
              break;
            default:
              notification.error({
                message: '提現失敗通知',
                description: `未知 ${data.Meta.RealAmount}`,
                placement: 'top',
              });
              break;
          }
        }
      }
    });

    socket.on('notification.info', async (data) => {
      console.log('[socket] notification.info', data);
      notification.info(data)
    })

    socket.on('notification.success', async (data) => {
      console.log('[socket] notification.success', data);
      notification.success(data)
    })

    socket.on('notification.error', async (data) => {
      console.log('[socket] notification.error', data);
      notification.error(data)
    })

    socket.on('notification.warn', async (data) => {
      console.log('[socket] notification.warn', data);
      notification.warn(data)
    })

    this.context.setSocket(socket);

    setInterval(() => {
      this.setState({ time: new Date() });
    }, 1000);

    // const test = {
    //   id: '75e52630-8c90-4414-973f-ea38f9ad03f0',
    //   uid: 'jason123456',
    //   coin: -100,
    //   status: 1,
    //   createdAt: '2025-07-03T02:25:46.000Z',
    //   testFail: 1,
    //   otc_id: '0197cfd2-2b2f-7430-805c-ddf3a82a4567'
    // }
    // if (test.coin < 0)
    //   if (test.otc_id) return alert(1)
    //   else alert(2)
    // else
    //   if (test.otc_id) return alert(3)
    //   else alert(4)

  }

  render() {
    return (
      <>
        {!this.context.user ? (
          <StatusBar
            time={this.state.time}
            onCheckBalance={() => this.onCheckBalance()}
          />
        ) : (
          <StatusBarAuthed
            // goto ModalBindSelect
            showModalBindSelect={() => this.context.setShowBindSelect(true)}
            onUnbindUser={() => this.onUnbindUser()}
            // goto ModalTrancSelect
            showModalTrancSelect={() => {
              this.context.setCoinValue(100);
              this.context.setShowTrancSelect(true);
            }}
            showModalWithdrawSelect={() => {
              this.context.setCoinValue(100);
              this.context.setShowWithdrawSelect(true);
            }}
            time={this.state.time}
            showModalOrders={() => {
              this.context.setShowOrders(true);
            }}
          />
        )}

        <AppBar />
        <GameCarousel />
        <InfoSection />
        <GameList />
        <Footer />

        {/* <SideMenu /> */}

        <ModalRegister onRegister={this.onRegister} />
        <ModalTranc
          onTranc={this.onTranc}
          onTestFailTranc={this.onTestFailTranc}
        />
        <ModalWaiting />
        <ModalWithdraw
          onWithdraw={this.onWithdraw}
        />

        <ModalTrancSelect
          // goto ModalTranc
          showModalTranc={() => this.context.setShowTranc(true)}
        />

        <ModalWithdrawSelect
          // goto ModalWithdraw
          showModalWithdraw={() => this.context.setShowWithdraw(true)}
        />

        <ModalQR />
        <ModalBindSelect
          onClickBindMatchPay={() => this.onClickBindMatchPay()}
        // onSelectLink={() => this.onBindUserLink()}
        />
        <ModalOrders />
      </>
    );
  }

  /**
   * 註冊用戶
   * @param {RegistData} data - 用戶註冊信息
   */
  onRegister = async (data) => {
    const { uid, password, nickname, wid } = data;
    this.context.setShowRegister(false);
    console.log(`uid = ${uid}`);
    console.log(`password = ${password}`);
    console.log(`nickname = ${nickname}`);
    console.log(`wid = ${wid}`);
    await this.context.register(data);
  };

  onBindUser = async (wid) => {
    const data = await this.context.fetchApi(`/api/binduser`, {
      uid: this.context.user.uid,
      // wid: this.context.user.wid,
      wid: wid,
    });
    console.log(data);

    if (data.errorCode === 0) {
      // window.open(data.url);
      notification.success({
        message: i18n.t('Home.Bind'),
        description: i18n.t('Home.Success'),
      });

      // 更新畫面
      await this.context.refreshUser();
    } else {
      notification.error({
        message: i18n.t('Home.Bind'),
        description: i18n.t('Home.Fail'),
      });
    }
  };

  openWindowAndWatch = async (url) => {
    this.context.setShowWaiting(true);
    // const newWindow = window.open('https://example.com', '_blank', 'width=600,height=400');
    const newWindow = window.open(
      url,
      '_blank',
      'width=500,height=600,menubar=no,toolbar=no,location=no,status=no,resizable=no,scrollbars=yes'
    );

    if (!newWindow) {
      alert('無法開啟視窗，可能被瀏覽器阻擋');
      this.context.setShowWaiting(false);
      return;
    }

    const checkClosed = setInterval(async () => {
      if (newWindow.closed) {
        clearInterval(checkClosed);
        console.log('視窗已關閉，更新記錄綁定...');
        this.context.setShowWaiting(false);

        // 更新畫面
        await this.context.refreshUser();

        if (this.context.user.wid !== '') {
          notification.success({
            message: i18n.t('Home.Bind'),
            description: i18n.t('Home.Success'),
          });
        } else {
          notification.error({
            message: i18n.t('Home.Bind'),
            description: i18n.t('Home.Fail'),
          });
        }
      }
    }, 1000);
  };

  onClickBindMatchPay = async () => {
    const data = await this.context.fetchApi(`/api/getBindUrl`, {
      uid: this.context.user.uid,
    });
    console.log(data);

    if (data.errorCode === 0) {
      console.log("跳轉綁定頁面");
      notification.info({
        message: i18n.t('Home.Bind'),
        description: i18n.t('Home.OpenWindowAndBinding'),
      });
      this.openWindowAndWatch(data.response);
    } else {
      notification.error({
        message: i18n.t('Home.Bind'),
        description: i18n.t('Home.GetBindUrlFailed'),
      });
    }
  };

  // onClickBindMatchPay = async () => {
  //   this.context.setShowBindSelect(false);

  //   let BindName = this.context.user.wid;
  //   let storeId = this.context.storeId; // "87c0bbdb-d6f6-11ee-b54f-02420a000008"
  //   const OrderId = uuidv4();

  //   let qrCodeurl = `${this.context.url}/#/home/`;
  //   qrCodeurl += `?actionType=withdraw`;
  //   qrCodeurl += `&StoreID=${storeId}`;
  //   qrCodeurl += `&BindName=${BindName}`;
  //   qrCodeurl += `&amount=${amount * Math.pow(10, scale)}`;
  //   // qrCodeurl += `&note=${note}`
  //   let newNote = {
  //     BindName: this.context.user.uid,
  //     OrderId: OrderId,
  //   };
  //   qrCodeurl += `&note=${JSON.stringify(newNote)}`;

  //   let QrCodeFileName = `Deposit_${amount}_To_${this.context.user.uid}`;

  //   // 建單
  //   console.log('this.context.user', this.context.user);
  //   console.log('this.context.session', this.context.session);
  //   /** @type {TrancRequest} */
  //   const requestBody = {
  //     session: this.context.session,
  //     amount: amount,
  //     method: method,
  //     OrderId: OrderId,
  //   };
  //   const gameApiResponse = await this.context.fetchApi(
  //     `/api/tranc`,
  //     requestBody
  //   );
  //   console.log('gameApiResponse', gameApiResponse);
  //   if (gameApiResponse) {
  //     /**
  //      * @param {TrancResponse} res
  //      */
  //     this.context.setModalQR({
  //       Show: true,
  //       Value: qrCodeurl,
  //       FileName: QrCodeFileName,
  //       Title: 'QRCode 充值',
  //     });
  //   }
  // };

  // 沒用的先註解掉
  // onBindUserLink = async () => {
  //   //const winRef = window.open('', '_blank');
  //   const data = await this.context.fetchApi(`/api/binduser`, {
  //     wid: this.context.user.wid,
  //     method: 'new',
  //     redirect_url: 'Y',
  //   });

  //   if (data && data.errorCode === 0) {
  //     this.context.setModalQR({
  //       Show: true,
  //       Value: data.url,
  //       FileName: this.context.user.wid,
  //       Title: '綁定錢包',
  //     });
  //     //winRef.location = data.url;
  //   } else {
  //     message.error(`API error:${data}`);
  //     return null;
  //   }
  // };

  onTranc = async (amount, method) => {
    let minAmount = method === 'usdt' ? 15 : 10;
    if (amount < minAmount) {
      message.error('抱歉! 您輸入的金額不能小於 ' + minAmount);
      return null;
    }

    if (amount > 10000) {
      message.error('抱歉! 您輸入的金額不能大於 10000');
      return null;
    }

    // if (amount % 50 !== 0) {
    //   message.error('抱歉! 您輸入的金額必須為 50 的倍數');
    //   return null;
    // }

    let coinType = method === 'usdt' ? 'USDT' : this.context.symbol;

    Modal.confirm({
      title: i18n.t('Home.ConfirmTitle'),
      content: i18n.t('Home.AreYouSureToDepositThisMoney', {
        amount: amount,
        coinType: coinType,
      }),
      onOk: () => this.onTrancConfirm(amount, method),
      onCancel: () => { },
      okText: i18n.t('Home.ConfirmButton'),
      cancelText: i18n.t('Home.CancelButton'),
    });
  };

  onTrancFail = async (amount, method) => {
    console.log(`onTrancFail:${method}`);

    let minAmount = method === 'fail_usdt' ? 15 : 10;
    if (amount < minAmount) {
      message.error('抱歉! 您輸入的金額不能小於 ' + minAmount);
      return null;
    }

    // if (amount < 100) {
    //   message.error('抱歉! 您輸入的金額不能小於 100');
    //   return null;
    // }

    if (amount > 10000) {
      message.error('抱歉! 您輸入的金額不能大於 10000');
      return null;
    }

    // if (amount % 50 !== 0) {
    //   message.error('抱歉! 您輸入的金額必須為 50 的倍數');
    //   return null;
    // }

    let coinType = method === 'fail_usdt' ? 'USDT' : this.context.symbol;

    Modal.confirm({
      title: i18n.t('Home.ConfirmTitle'),
      content: i18n.t('Home.AreYouSureToDepositThisMoney', {
        amount: amount,
        coinType: coinType,
      }),
      onOk: () => this.onTrancFailConfirm(amount, method),
      onCancel: () => { },
      okText: i18n.t('Home.ConfirmButton'),
      cancelText: i18n.t('Home.CancelButton'),
    });
  };

  onWithdraw = async (param) => {
    const { amount, callback, testFail } = param;
    console.log(amount);

    if (amount < 1) {
      message.error('抱歉! 您輸入的金額不能小於 1');
      return null;
    }

    if (amount > 10000) {
      message.error('抱歉! 您輸入的金額不能大於 10000');
      return null;
    }

    Modal.confirm({
      title: i18n.t('Home.ConfirmTitle'),
      content: i18n.t('Home.AreYouSureToWithdrawThisMoney', {
        amount: amount,
        coinType: this.context.symbol,
      }),
      onOk: () => this.onWithDrawConfirm(amount, callback, testFail),
      onCancel: () => { },
      okText: i18n.t('Home.ConfirmButton'),
      cancelText: i18n.t('Home.CancelButton'),
    });
  };

  onTrancConfirm = async (amount, method) => {
    console.log(
      '🚀 ~ Home ~ onTrancConfirm= ~ amount, method:',
      amount,
      method
    );
    this.context.setShowTranc(false);
    this.context.setShowTrancUSDT(false);

    let accountId = this.context.accountId; // "87c0bbdb-d6f6-11ee-b54f-02420a000008"
    let tokenId = this.context.tokenId;
    const OrderId = uuidv4();

    const scale = 6;
    console.log('scale: ', 6);
    console.log('amount needs to multiply: ', Math.pow(10, scale));
    console.log('new amount: ', amount * Math.pow(10, scale));

    let qrCodeurl = `${this.context.url}/#/home/`;
    qrCodeurl += `?actionType=transfer`;
    qrCodeurl += `&accountID=${accountId}`;
    qrCodeurl += `&tokenID=${tokenId}`;
    qrCodeurl += `&amount=${amount * Math.pow(10, scale)}`;
    // qrCodeurl += `&note=${note}`
    let newNote = {
      BindName: this.context.user.uid,
      OrderId: OrderId,
    };
    qrCodeurl += `&note=${JSON.stringify(newNote)}`;

    let QrCodeFileName = `Deposit_${amount}_To_${this.context.user.uid}`;

    // 建單
    console.log('this.context.user', this.context.user);
    console.log('this.context.session', this.context.session);
    /** @type {TrancRequest} */
    const requestBody = {
      session: this.context.session,
      amount: amount,
      method: method,
      OrderId: OrderId,
    };
    const gameApiResponse = await this.context.fetchApi(
      `/api/tranc`,
      requestBody
    );
    console.log('gameApiResponse', gameApiResponse);
    if (gameApiResponse) {
      /**
       * @param {TrancResponse} res
       */
      this.context.setModalQR({
        Show: true,
        Value: qrCodeurl,
        FileName: QrCodeFileName,
        Title: 'QRCode 充值',
      });
    }
  };

  onTrancFailConfirm = async (amount, method) => {
    this.context.setShowTranc(false);
    this.context.setShowTrancUSDT(false);

    const data = await this.context.fetchApi(`/api/tranc`, {
      amount: amount,
      cid: this.context.user.uid,
      method: method,
    });

    let qrCodeurl = data.url;
    // 判斷是否有錯誤訊息
    if (qrCodeurl.search('yapay') !== -1) {
      this.context.setModalQR({
        Show: true,
        Value: data.url,
        FileName: '',
        Title: 'QRCode 轉帳',
      });
    } else {
      notification.error({
        message: '錯誤',
        description: qrCodeurl,
      });
    }
  };

  onWithDrawConfirm = async (amount, callback, testFail) => {
    this.context.setShowWithdraw(false);
    let response = await this.context.fetchApi(`/api/withdraw`, {
      amount: amount,
      uid: this.context.user.uid,
      cid: this.context.user.wid,
      callback: callback,
      testFail: testFail,
    });
    if (!response) {
      // 代表裡面直接 throw error 了
      return;
    }

    const { errorCode } = response;
    console.log('🚀 ~ Home ~ onWithDrawConfirm= ~ errorCode:', errorCode);
    if (errorCode === E_BALANCE_NOT_ENOUGH) {
      notification.error({
        message: '提現失敗通知',
        description: `餘額不足`,
        placement: 'top',
      });

      return;
    }

    // 能到這裡的只有未綁定的 case
    if (errorCode === E_FAILED_APICALL_TO_APIBK_WITHDRAW) {
      // TODO: 不用判斷了 能到這裡的只有未綁定的 case
      console.log('onWithDrawConfirm(): E_FAILED_APICALL_TO_APIBK_WITHDRAW');
      // 跳出綁定 QR Code
      const host = this.context.url;
      const page = `#/login`;
      let query = new URLSearchParams();

      query.set('actionType', 'withdraw');

      const { BindingInfo } = response;
      if (BindingInfo === undefined) {
        console.log('withdraw error but no binding info');
        console.log(response);
        return;
      }
      const { StoreID, BindName, Signature } = BindingInfo;
      query.set('StoreID', `${StoreID}`);
      query.set('BindName', `${BindName}`);
      query.set('Signature', `${Signature}`);

      let qrCodeUrl = `${host}/${page}?${query.toString()}`;
      console.log(qrCodeUrl);
      let QrCodeFileName = `Player_${this.context.user.uid}_Binding_QRCode`;
      this.context.setModalQR({
        Show: true,
        Value: qrCodeUrl,
        FileName: QrCodeFileName,
        Title: 'QRCode 綁定錢包',
      });
      return;
    }

    // 提款成功，更新資料
    // 更新畫面
    this.context.refreshUser();
  };

  onTestFailTranc = async (amount) => {
    this.context.setShowTranc(false);
    this.context.setShowTrancUSDT(false);

    let accountId = this.context.accountId; // "87c0bbdb-d6f6-11ee-b54f-02420a000008"
    let tokenId = this.context.tokenId;
    const OrderId = uuidv4();

    const scale = 6;

    let qrCodeurl = `${this.context.url}/#/home/`;
    qrCodeurl += `?actionType=transfer`;
    qrCodeurl += `&accountID=${accountId}`;
    qrCodeurl += `&tokenID=${tokenId}`;
    qrCodeurl += `&amount=${amount * Math.pow(10, scale)}`;
    // qrCodeurl += `&note=${note}`
    let newNote = {
      BindName: this.context.user.uid,
      OrderId: OrderId,
    };
    qrCodeurl += `&note=${JSON.stringify(newNote)}`;

    let QrCodeFileName = `Deposit_${amount}_To_${this.context.user.uid}`;

    // 建單
    console.log('this.context.user', this.context.user);
    /** @type {TrancRequest} */
    const requestBody = {
      session: this.context.session,
      amount: amount,
      OrderId: OrderId,
    };
    const gameApiResponse = await this.context.fetchApi(
      `/api/test-fail-tranc`,
      requestBody
    );
    console.log('gameApiResponse', gameApiResponse);
    if (gameApiResponse) {
      /**
       * @param {TrancResponse} res
       */
      this.context.setModalQR({
        Show: true,
        Value: qrCodeurl,
        FileName: QrCodeFileName,
        Title: 'QRCode 充值',
      });
    }
  };

  onUnbindUser = async () => {
    Modal.confirm({
      title: i18n.t('Home.ConfirmTitle'),
      content: i18n.t('Home.AreYouSureToUnbind'),
      onOk: () => this.onUnbindUserConfirm(),
      onCancel: () => { },
      okText: i18n.t('Home.ConfirmButton'),
      cancelText: i18n.t('Home.CancelButton'),
    });
  };

  onUnbindUserConfirm = async () => {
    const res = await this.context.fetchApi(`/api/unbinduser`, {
      uid: this.context.user.uid,
    });
    if (res) {
      // 更新畫面
      this.context.refreshUser();
    }
  };

  onCheckBalance = async () => {
    this.context.fetchApi(`/api/get-balance`, {}).then((res) => {
      if (res) {
        notification.success({
          message: '娛樂城 E Pay 餘額',
          description: `${res.RealAmount}`,
          placement: 'top',
        });
      }
    });
  };
}
